"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DomHelper {
}
DomHelper.fakeButtonAccessibilityKey = (e, callback) => {
    if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        if (!!callback) {
            callback(e);
        }
        else {
            e.currentTarget.click();
        }
    }
};
DomHelper.setFocus = (element) => {
    if (element) {
        element.focus();
    }
};
exports.DomHelper = DomHelper;
